export default "__VITE_ASSET__DBbBYTs5__"